import { FC } from 'react';
import { ListSubheader } from '@mui/material';

interface Props {
  label: string;
  shouldShow: boolean;
}

export const StretchGroupHeader: FC<Props> = ({ label, shouldShow }) => {
  if (!shouldShow) return null;

  return (
    <ListSubheader
      sx={{
        color: 'mcBlue.darker',
        fontWeight: 'bold',
        paddingLeft: 2,
      }}
      disableSticky
      disableGutters
    >
      {label}
    </ListSubheader>
  );
};
